import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MobileForwardComponent } from './shared/component/mobile-forward/mobile-forward.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('../app/auth/auth.module').then((m) => m.AuthModule) },
  { path: 'mobile', component: MobileForwardComponent },
  { path: 'haulier', loadChildren: () => import('../app/haulier/haulier.module').then((m) => m.HaulierModule) },
  { path: 'shipper', loadChildren: () => import('../app/shippers/shippers.module').then((m) => m.ShippersModule) },
  { path: 'super-admin', loadChildren: () => import('../app/admin/admin.module').then((m) => m.AdminModule) },
  {
    path: 'invitations',
    loadChildren: () => import('../app/invitation/invitation.module').then((m) => m.InvitationModule),
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
